module.exports = __webpack_public_path__ + "static/media/check.ec941510.svg";